<template>
  <div
    v-if="valores.length > 0"
    class="eixo-x-flutuante"
    :style="{ paddingLeft: `${margemEsquerda}px` }"
  >
    <span
      v-for="(valor, index) in valores"
      :key="index"
      class="eixo-x-item"
    >
      {{ valor }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'EixoXFlutuante',
  props: {
    valores: {
      type: Array,
      default: () => [],
    },
    margemEsquerda: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped>
.eixo-x-flutuante {
  position: relative;
  width: 100%;
  background-color: transparent;
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 20;
  flex-shrink: 0;
}

.eixo-x-item {
  font-size: 12px;
  color: #666;
  flex: 1;
  text-align: left;
}
</style>
